<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/vip'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg t="1653550410309"
                     viewBox="0 0 1024 1024"
                     version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     p-id="2364"
                     width="64"
                     height="64">
                  <path d="M561.71026963 133.50290015a77.6722963 77.6722963 0 0 1 9.96794429 9.96794429L719.12612386 320.40833539l162.64578845-120.10726042a77.6722963 77.6722963 0 0 1 121.50536177 81.29700386L848.57995022 900.36148148H175.42004978L20.72272592 281.62396918a77.6722963 77.6722963 0 0 1 121.50536177-81.32289421L304.87387614 320.40833539l147.44790994-176.93749095a77.6722963 77.6722963 0 0 1 109.41437391-9.96794429zM512 193.18111406l-194.33608533 233.22401542-221.57317098-163.62963793L236.05622162 822.68918518h551.88755676l139.96547793-559.91369363-221.57317098 163.62963793L512 193.18111406z m181.23535762 486.22857483v82.85044978H330.76464238v-82.85044978h362.47071524z"
                        p-id="2365"></path>
                </svg>
                微信支付
              </h2>
            </div>
            <div class="box">
              <div class="box-content"
                   v-loading="loading">
                <div class="pay-info">
                  <div class="order-info">订单提交成功，请尽快付款！</div>
                  <div class="cost">¥ {{ payMoney }}</div>
                </div>
                <div class="pay-code">
                  <div class="tips">
                    <ul>
                      <li>
                        操作方式：打开手机微信，扫描下方的二维码，并按提示完成支付操作即可！
                      </li>
                    </ul>
                  </div>
                  <div class="qrcode-box wechat-code">
                    <div class="qrcode">
                      <div class="qrcode-img"
                           ref="qrCodeDiv">
                        <!-- <el-image :src="codeImg" alt="加载中..."></el-image> -->
                        <!-- <img
                            src="/Qikan/UserPay/GetQrCode?qrCodeUrl=weixin%3a%2f%2fwxpay%2fbizpayurl%3fpr%3dpJzupuDzz"
                          /> -->
                      </div>
                      <div class="qrcode-tips">
                        <svg t="1648002256729"
                             class="icon"
                             viewBox="0 0 1024 1024"
                             version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             p-id="3635"
                             width="18"
                             height="18">
                          <path d="M55.808 717.312H10.24v250.88C10.24 993.28 30.6176 1013.76 55.808 1013.76h250.88v-45.568h-250.88v-250.88z m0-661.504h250.88V10.24h-250.88C30.6176 10.24 10.24 30.6176 10.24 55.808v250.88h45.568v-250.88z m912.2816 912.384h-250.88V1013.76h250.88c25.1904 0 45.568-20.48 45.568-45.568v-250.88h-45.568v250.88z m0-957.952h-250.88v45.568h250.88v250.88H1013.76v-250.88c0-25.1904-20.3776-45.568-45.6704-45.568z m22.8352 478.9248H33.0752C20.48 489.1648 10.24 499.4048 10.24 512s10.24 22.8352 22.8352 22.8352h957.952c12.5952 0 22.8352-10.24 22.8352-22.8352-0.1024-12.5952-10.3424-22.8352-22.9376-22.8352z"
                                p-id="3636"></path>
                        </svg>
                        请使用微信扫一扫<br />
                        扫描二维码支付
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";
import QRCode from "qrcodejs2";

export default {
  components: { UserLeftGuid },
  data () {
    return {
      loading: false,
      codeImg: "",
      payMoney: this.$route.query.PayMoney || 0,
      timer: null,
      time: 60 * 5, //五分钟,
      interval: null,
      memberTypeId: this.$route.query.MemberTypeId || 0,
      jifenTypeId: this.$route.query.JifenTypeId || 0,
      orderNumber: "",
      getOrderPayStatusUrl: "",
      getOrderPayStatusInterval: null,
      getOrderPayStatusLoading: false,
    };
  },
  created () {
    this.loading = true;
  },
  mounted () {
    if (this.memberTypeId) {
      this.getOrderPayStatusUrl = "/vip/order-pay-status";
      this.getPayQRCode("/vip/wechat-pay-code-url", { id: this.memberTypeId });
    } else if (this.jifenTypeId) {
      this.getOrderPayStatusUrl = "/vip/order-pay-jifen-status";
      this.getPayQRCode("/vip/wechat-pay-jifen-code-url", {
        type: this.jifenTypeId,
      });
    }
  },
  methods: {
    getPayQRCode (url, data) {
      axiosRequest(url, data, axiosOptions("post", "", "json"))
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            let qrCode = new QRCode(this.$refs.qrCodeDiv, {
              text: res.data.data.code_url,
              width: 220,
              height: 220,
              colorDark: "#333333", //二维码颜色
              colorLight: "#ffffff", //二维码背景色
              correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
            });
            qrCode._el.title = "";
            this.orderNumber = res.data.data.out_trade_no;
            this.getOrderPayStatusInterval = setInterval(
              this.getOrderPayStatus,
              3000
            );
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getOrderPayStatus () {
      if (this.getOrderPayStatusLoading) {
        return;
      }

      this.getOrderPayStatusLoading = true;
      axiosRequest(
        this.getOrderPayStatusUrl,
        { orderNumber: this.orderNumber },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data) {
              if (res.data.data === 1) {
                this.$router.push({
                  path: "/pay_success",
                  query: { total_amount: this.payMoney },
                });
              }

              if (res.data.data > 0) {
                clearInterval(this.getOrderPayStatusInterval);
              }
            }
          }
          this.getOrderPayStatusLoading = false;
        })
        .catch(() => {
          this.getOrderPayStatusLoading = false;
        });
    },
    dateFormat (cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  beforeDestroy () {
    if (this.getOrderPayStatusInterval) {
      clearInterval(this.getOrderPayStatusInterval);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/usercenter.scss";
.pay-info {
  position: relative;
  margin: 15px 0;
  padding: 20px;
  background: #eaf3f5;
  .cost {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 180px;
    height: 57px;
    font-size: 30px;
    line-height: 55px;
    text-align: center;
    color: #dd0000;
    background: #fff;
    border: 1px solid #ccc;
  }
}
.order-info {
  padding-right: 200px;
  font-size: 16px;
  line-height: 57px;
}
.pay-code {
  width: 700px;
  margin: 0 auto;
  padding: 20px;
}
.pay-code .tips {
  margin-bottom: 20px;
}
.pay-code .tips li {
  line-height: 22px;
}
.pay-code .qrcode-box {
  padding: 20px 0;
}
.pay-code .qrcode-box:before,
.pay-code .qrcode-box:after {
  display: table;
  content: "";
  clear: both;
}
.pay-code .qrcode {
  float: left;
  width: 300px;
}
.pay-code .qrcode-img {
  width: 300px;
  height: 300px;
  margin-bottom: 20px;
  padding: 39px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.pay-code .qrcode-img img {
  width: 220px;
  height: 220px;
}
.pay-code .qrcode-tips {
  height: 60px;
  padding: 10px 15px;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  background: #0e932e;
  box-sizing: border-box;
}
.pay-code .qrcode-tips svg {
  float: left;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.pay-code .qrcode-tips i:before {
  font-size: 40px;
  position: relative;
  top: 12px;
}
.wechat-code {
  background: url(~@/assets/images/wechat-scan.png) no-repeat right top;
}
@media screen and (max-width: 768px) {
  .order-info {
    padding-right: 0;
  }
  .pay-info {
    .cost {
      position: static;
    }
  }
  .pay-code {
    width: auto;
    padding: 0;
    .qrcode-box {
      text-align: center;
      background-image: none;
    }
    .qrcode {
      display: inline-block;
      width: auto;
      float: none;
    }
    .qrcode-img {
      width: 100%;
      height: auto;
      padding: 20px;
      background-color: #fff;
    }
  }
}
</style>
